import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WhatWeGot.css';

function WhatWeGot() {
  const navigate = useNavigate();

  return (
    <div className="what-we-got">
      <div className="what-we-got-title">What We Got</div>
      <div className="what-we-got-grid">
        <div className="option-card" style={{ backgroundImage: "url('https://www.foodrepublic.com/wp-content/uploads/2018/03/shawarma-1240x1022.jpg')" }} onClick={() => navigate('/Food')}>
          <div className="text-container">
            <h3 className="option-title">Food</h3>
            <p className="option-description">
              Enjoy treats from our frequent food trucks or bring your own.
            </p>
          </div>
        </div>

        <div className="option-card" style={{ backgroundImage: "url('https://www.emporiotambo.com.br/pub/media/resized/1300x800/ves/blog/balcao-bar-de-casa.jpg')" }} onClick={() => navigate('/Bar')}>
          <div className="text-container">
            <h3 className="option-title">Drinks</h3>
            <p className="option-description">
              Full-service bar with a wide selection of drinks.
            </p>
          </div>
        </div>

        {/* Coming Soon Mode: Day Passes & Memberships card temporarily hidden until pricing is ready */}
        {/* TODO: Uncomment when business opens and pricing is ready to be displayed */}
        {/* <div className="option-card" style={{ backgroundImage: "url('https://th.bing.com/th/id/OIP.hSUW08s7ukEwchDuC1rVrwHaE2?rs=1&pid=ImgDetMain')" }} onClick={() => navigate('/Dog-Passes')}>
          <div className="text-container">
            <h3 className="option-title">Day Passes & Memberships</h3>
            <p className="option-description">
              Get a day pass or monthly membership to maximize the fun.
            </p>
          </div>
        </div> */}

        <div className="option-card" style={{ backgroundImage: "url('https://i.pinimg.com/originals/bd/c8/6d/bdc86d519a0496633b6d7ab8250bec73.jpg')" }} onClick={() => navigate('/Merchandise')}>
          <div className="text-container">
            <h3 className="option-title">Swag</h3>
            <p className="option-description">
              Unique merchandise for you and your pup.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default WhatWeGot;
